'use strict';

var _typeof = require("@babel/runtime/helpers/typeof");
var own = {}.hasOwnProperty;
module.exports = stringify;
function stringify(value) {
  /* Nothing. */
  if (!value || _typeof(value) !== 'object') {
    return null;
  }

  /* Node. */
  if (own.call(value, 'position') || own.call(value, 'type')) {
    return position(value.position);
  }

  /* Position. */
  if (own.call(value, 'start') || own.call(value, 'end')) {
    return position(value);
  }

  /* Point. */
  if (own.call(value, 'line') || own.call(value, 'column')) {
    return point(value);
  }

  /* ? */
  return null;
}
function point(point) {
  if (!point || _typeof(point) !== 'object') {
    point = {};
  }
  return index(point.line) + ':' + index(point.column);
}
function position(pos) {
  if (!pos || _typeof(pos) !== 'object') {
    pos = {};
  }
  return point(pos.start) + '-' + point(pos.end);
}
function index(value) {
  return value && typeof value === 'number' ? value : 1;
}
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/unist-util-stringify-position/index.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/unist-util-stringify-position/index.js");
  }
}();